var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"change-lang"},[_c('img',{staticClass:"btn",attrs:{"src":require(("../assets/pc-change-images/language-" + (this.$i18n.locale) + ".png")),"alt":"#"},on:{"click":_vm.changeLang}}),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }